import { SECURE_URL_PARAMS } from 'constants/urlParams';

export const getAllowedAuthQueryParams = (search: string) => {
    const params = new URLSearchParams(search);

    SECURE_URL_PARAMS.forEach((param) => params.delete(param));

    return params.size > 0 ? `?${params.toString()}` : '';
};

export const getQueryParamFromUrl = (param: string, url: string = window.location.href) => {
    const searchParams = new URL(url).search;
    const searchParamsObj = new URLSearchParams(searchParams);

    return searchParamsObj.get(param);
};

export const deleteQueryParamsFromUrl = (params: string[], url = window.location.href) => {
    const { search, pathname } = new URL(url);
    const searchParamsObj = new URLSearchParams(search);

    params.forEach((element) => {
        searchParamsObj.delete(element);
    });

    return searchParamsObj.size > 0 ? `${pathname}?${searchParamsObj.toString()}` : pathname;
};
